// Analytics transport: POST a batch to the `dashoneTrackEvents` Firebase
// function with the caller's Firebase ID token. Mirrors the trackUserAction
// transport, with `keepalive: true` added so an in-flight flush survives the
// page unload (sendBeacon can't carry the Authorization header, so it's not an
// option). Never throws — returns false so the queue can re-queue and retry.

import { auth } from '@/utils/firebase';
import type { OutgoingEvent } from './types';

export async function send(events: OutgoingEvent[]): Promise<boolean> {
  if (events.length === 0) return true;
  try {
    const idToken = await auth.currentUser?.getIdToken();
    if (!idToken) return false;
    const base = import.meta.env.VITE_FIREBASE_FUNCTIONS_URL as string | undefined;
    if (!base) return false;

    const res = await fetch(`${base.replace(/\/+$/, '')}/dashoneTrackEvents`, {
      method: 'POST',
      keepalive: true,
      headers: {
        Authorization: `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ events }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
